<template>
    <div v-if="showPaymentDate" class="pdo">
        <img v-if="hasIcon" src="@/assets/img/icons/calendar.svg" alt="" tabindex="-1" />
        <p 
            v-if="isPixOpenFinancePayment"
            v-text="$ml.get('pixOpenFinancePayToday') + ' (' + pixOpenFinancePaymentDate + ')'"
        />
    </div>
</template>

<script>
  import PaymentTypes from '@/models/PaymentTypes';
  import { mapGetters } from 'vuex';

  export default {
    props: {
        hasIcon: {
            type: Boolean,
            default: false
        }
    },

    computed: {
    ...mapGetters({
        selectedPaymentMethod: 'payment/getSelectedPaymentMethod',
        pixOpenFinancePaymentDate: 'pixOpenFinancePayment/getPaymentDate'
    }),

    isPixOpenFinancePayment: self =>
        self.selectedPaymentMethod &&
        (self.selectedPaymentMethod.PaymentType == PaymentTypes.PIX_OPEN_FINANCE),

    showPaymentDate() {
        if(this.$store.state.payment.PaymentType === 9) {
            return this.selectedPaymentMethod && this.$store.state.pixOpenFinancePayment.paymentDate;
        }

        return false;
    },
    }
  };
</script>

<style lang="scss" scoped>
    .pdo {
        display: flex;

        img {
            margin-right: 12px;
        }

        p {
            font-size: 16px;
            font-weight: 500;
            color: #000000;
            margin: 0;
        }
    }
</style>
